import type { IChallenge } from "@bbj-types/challenge";
import type { ISocialOffer } from "@bbj-types/offer";
import type { IFup } from "@bbj-types/socialApply/fup";
import type { ISocialApply } from "@bbj-types/socialApply/index.js";
import type { ObjectId, Override } from "@bbj-types/utils";
import type { TFupModalRecipient } from "@candidate/views/modals/FupModal/referent/recipient/resolver";
import type { TEmailForm } from "@data-display/EmailForm/resolver";
import { useCallback } from "react";
import type { IGetActionsData } from "../../action";
import { axios } from "../axios";

export type ISocialApplyFupBody = Omit<
  ISocialApply,
  "_id" | "createdAt" | "updatedAt" | "transitions" | "socialOffer" | "status" | "fup"
> & {
  socialOffer: Omit<ISocialOffer, "creator" | "editor" | "perimeter">;
  challenges: IChallenge["_id"][];
  fup: Omit<IFup, "partner">;
};

type ISendFupPostBody = ISocialApplyFupBody & {
  email: Override<TEmailForm, { attachments?: ObjectId[] }>;
  userPartner: Required<TFupModalRecipient>;
};

export interface ISendFupPostResponse {
  socialApply: ISocialApply[];
  action: IGetActionsData;
}

export const usePostSendFupToPartner = () => {
  const [state, execute, cancel] = axios<ISendFupPostResponse, ISendFupPostBody, unknown>(
    {
      url: "/applies/social/fup/partner",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: ISendFupPostBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
